import React, { useState } from 'react';

import { Technique } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
import { Dustbin, Edit } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import { ServerErrorRed } from '@randstad-lean-mobile-factory/react-assets/dist/illustrations';
import {
  Button,
  Loader,
  Modal,
  ModalActions,
  ModalContent,
  WithLightTitle,
  toast,
} from '@randstad-lean-mobile-factory/react-components-core';
import { useQueryClient } from '@tanstack/react-query';

import { useFetchOnCallCenterById } from '../../../Hooks/OnCallCenters/useFetchOnCallCenterById';
import { useRemoveAgenciesToOnCallCenter } from '../../../Hooks/OnCallCenters/useRemoveAgenciesToOnCallCenter';
import { QueryKeys } from '../../../Hooks/types';

import styles from './EditOnCallCenterModal.module.scss';
import { Props } from './EditOnCallCenterModal.types';

const EditOnCallCenterModalComponent = ({ onCallCenterId }: Props) => {
  const [open, setOpen] = useState(false);

  const {
    data: onCallCenter,
    isLoading,
    isSuccess,
  } = useFetchOnCallCenterById(onCallCenterId, { enabled: open });
  const queryClient = useQueryClient();

  const removeAgenciesFromOnCallCenterMutation = useRemoveAgenciesToOnCallCenter();
  return (
    <>
      <Button
        variant="tertiary"
        onClick={() => {
          setOpen(true);
        }}
      >
        <Edit variant="line" />
      </Button>
      <Modal size="medium" open={open} onClose={() => setOpen(false)}>
        <ModalContent title="modifier la permanence" header={<Technique />}>
          {isLoading ? (
            <Loader size="medium" variant="primary" />
          ) : isSuccess ? (
            <div className={styles.mainContainer}>
              <WithLightTitle title="permanence sélectionnée">
                <p className={styles.agencyList}>{onCallCenter?.onCallCenterId}</p>
              </WithLightTitle>
              <WithLightTitle
                title="liste des unités séléctionnées"
                className={styles.agencyListContainer}
                rightTitleComponent={
                  <p
                    className={styles.agencyCounter}
                  >{`${onCallCenter?.agencies.length} unité${onCallCenter?.agencies.length === 1 ? '' : 's'} `}</p>
                }
              >
                {onCallCenter?.agencies.map(agency => {
                  return (
                    <div className={styles.agencyRow}>
                      <p>{agency.agencyId}</p>
                      <Button
                        variant="tertiary"
                        onClick={() => {
                          removeAgenciesFromOnCallCenterMutation.mutate(
                            {
                              onCallCenterId: onCallCenterId,
                              agencies: [agency],
                            },
                            {
                              onSuccess: () => {
                                toast.success('Unité retirée de la permanence');
                                queryClient.invalidateQueries({
                                  queryKey: [QueryKeys.fetchOnCallCenterById],
                                });
                                queryClient.invalidateQueries({
                                  queryKey: [QueryKeys.fetchOnCallCenters],
                                });
                              },
                            }
                          );
                        }}
                      >
                        <Dustbin variant="line" />
                      </Button>
                    </div>
                  );
                })}
              </WithLightTitle>
            </div>
          ) : (
            <ServerErrorRed />
          )}
        </ModalContent>
        <ModalActions side="right">
          <Button
            variant="primary"
            type="submit"
            onClick={() => {
              setOpen(false);
            }}
          >
            fermer
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};

export default EditOnCallCenterModalComponent;
